<template>
  <div id="main-content" class="add-parent">
    <el-col :offset="1" :span="22">
      <PageTitle :title="title" :backLink="backLink"></PageTitle>
      <el-row class="row-section">
        <h3>{{ $t('common.basic_information') }}</h3>
      </el-row>
      <form>
        <el-row>
          <el-col :span="12" style="display: inline">
            <el-col :span="8">
              <span class="required-star">* </span><span class="form-lable"> {{ $t('add_parent.full_name') }}</span>
            </el-col>
            <input class="input" v-model="parent_data.name" type=""/>
            <el-col v-if="error_message.parent_name" :offset="8" :span="16">
              <span v-for="(value, key) in error_message.parent_name" :key="key" class="form-error"> {{ value }}</span>
            </el-col>
          </el-col>
          <el-col :span="12" style="display: inline;">
            <el-col :span="8">
              <span class="form-lable">{{ $t('common.gender') }}</span>
            </el-col>
            <el-select v-model="parent_data.gender" style="width: 60%; float: left">
              <el-option
                      v-for="gender in gender_type"
                      :key="gender.value"
                      :label="$t(gender.text)"
                      :value="gender.value">
              </el-option>
            </el-select>
          </el-col>
        </el-row>
        <el-row style="padding-top: 20px">
          <el-col :span="12" style="display: inline">
            <el-col :span="8">
              <span class="required-star">* </span><span class="form-lable"> {{ $t('common.furigana') }}</span>
            </el-col>
            <input class="input" v-model="parent_data.furigana" type=""/>
            <el-col v-if="error_message.parent_furigana" :offset="8" :span="16">
              <span v-for="(value, key) in error_message.parent_furigana" :key="key" class="form-error"> {{ value }}</span>
            </el-col>
          </el-col>
          <el-col :span="12" style="display: inline;">
            <el-col :span="8">
              <span class="form-lable">Romaji</span>
            </el-col>
            <input class="input" v-model="parent_data.romaji" type=""/>
          </el-col>
        </el-row>
        <el-row style="padding-top: 20px">
          <el-col :span="12" style="display: inline">
            <el-col :span="8">
              <span class="required-star">* </span><span class="form-lable">{{ $t('common.email') }}</span>
            </el-col>
            <input class="input" v-model="parent_data.email" type="email"/>
            <el-col v-if="error_message.email" :offset="8" :span="16">
              <span v-for="(value, key) in error_message.email" :key="key" class="form-error"> {{ value }}</span>
            </el-col>
          </el-col>
          <el-col :span="12" style="display: inline;">
            <el-col :span="8">
              <span class="form-lable">{{ $t('common.phone') }}</span>
            </el-col>
            <input class="input" v-model="parent_data.phone" type=""/>
            <el-col v-if="error_message.phone" :offset="8" :span="16">
              <span v-for="(value, key) in error_message.phone" :key="key" class="form-error"> {{ value }}</span>
            </el-col>
          </el-col>
        </el-row>
        <el-row style="padding-top: 20px">
          <el-col :span="12" style="display: inline">
            <el-col :span="8">
              <span class="form-lable">{{ $t('common.address_1') }}</span>
            </el-col>
            <input class="input" v-model="parent_data.address_1" type=""/>
          </el-col>
          <el-col :span="12" style="display: inline">
            <el-col :span="8">
              <span class="form-lable">{{ $t('common.address_2') }}</span>
            </el-col>
            <input class="input" v-model="parent_data.address_2" type=""/>
          </el-col>
        </el-row>
        <el-row style="padding-top: 20px">
          <el-col :span="12" style="display: inline">
            <el-col :span="8">
              <span class="form-lable">{{ $t('common.member') }}</span>
            </el-col>
            <input type="checkbox" v-model="parent_data.is_member" name="" value="">
          </el-col>
          <el-col :span="12" style="display: inline">
            <el-col :span="8">
              <span class="form-lable">{{ $t('common.active') }}</span>
            </el-col>
            <el-switch style="float: left;" v-model="parent_data.is_active"></el-switch>
          </el-col>
        </el-row>
        <el-row style="padding-top: 20px">
          <el-col :span="12" style="display: inline">
            <el-col :span="8">
              <span class="form-lable">{{ $t('common.image') }}</span>
            </el-col>
            <b-form-file
                    v-model="parent_data.image"
                    style="width: 60%; float: left"
                    :placeholder="$t('common.choose_file')"
                    :drop-placeholder="$t('common.drop_file')"
            ></b-form-file>
          </el-col>
        </el-row>

        <el-row class="row-section">
          <el-button @click="onAddFile" style="float: left; margin-left: 20px;" type="success" icon="el-icon-plus" circle></el-button>
          <span style="line-height: 40px;margin-left: 20px; font-size: 22px">{{ $t('add_parent.files') }}</span>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-row v-for="(file, indexF) in listFiles" :key="indexF" class="mb-2">
              <el-col :span="20">
                <div class="d-flex">
                  <span class="required-star">* </span><span class="form-lable text-file">{{ $t('categoryM.form.file') }}</span>
                  <b-form-file
                      id="parentFile"
                      accept=".xlsx,.xls,image/*,.doc, .docx,.ppt, .pptx,.txt,.pdf, .csv" v-model="listFiles[indexF]"
                      style="width: 100%; float: left"
                      :placeholder="$t('common.choose_file')"
                      :drop-placeholder="$t('common.drop_file')"
                  ></b-form-file>
                </div>
              </el-col>
              <el-col :span="4" class="d-flex">
                <i @click="onDeleteFile(indexF)" class="el-icon-close icon-move ml-4 text-danger"></i>
              </el-col>
            </el-row>
          </el-col>
        </el-row>

        <div class="partner-section">
          <el-row class="row-section">
            <h3>{{ $t('common.partner_information') }}</h3>
            <div class="partner-section__switch">
              <el-switch v-model="hasPartner">
              </el-switch>
            </div>
          </el-row>

          <div class="partner-section__body" v-show="hasPartner">
            <el-row style="padding-top: 20px">
              <el-col :span="12" style="display: inline">
                <el-col :span="8">
                  <span class="form-lable">{{ $t('common.full_name') }}</span>
                </el-col>
                <input class="input" v-model="parent_data.partner_info.name" type=""/>
                <el-col v-if="error_message.partner.name" :offset="8" :span="16">
                  <span v-for="(value, key) in error_message.partner.name" :key="key"
                        class="form-error"> {{ value }}</span>
                </el-col>
              </el-col>
              <el-col :span="12" style="display: inline">
                <el-col :span="8">
                  <span class="form-lable">{{ $t('common.gender') }}</span>
                </el-col>
                <el-select v-model="parent_data.partner_info.gender" style="width: 60%; float: left">
                  <el-option
                          v-for="gender in gender_type"
                          :key="gender.value"
                          :label="$t(gender.text)"
                          :value="gender.value">
                  </el-option>
                </el-select>
              </el-col>
            </el-row>
            <el-row style="padding-top: 20px">
              <el-col :span="12" style="display: inline">
                <el-col :span="8">
                  <span class="form-lable">{{ $t('common.furigana') }}</span>
                </el-col>
                <input class="input" v-model="parent_data.partner_info.furigana" type=""/>
              </el-col>
              <el-col :span="12" style="display: inline">
                <el-col :span="8">
                  <span class="form-lable">{{ $t('common.romaji') }}</span>
                </el-col>
                <input class="input" v-model="parent_data.partner_info.romaji" type=""/>
              </el-col>
            </el-row>
            <el-row style="padding-top: 20px">
              <el-col :span="12" style="display: inline">
                <el-col :span="8">
                  <span class="form-lable">{{ $t('common.email') }}</span>
                </el-col>
                <input class="input" v-model="parent_data.partner_info.email" type=""/>
                <el-col v-if="error_message.partner.email" :offset="8" :span="16">
                  <span v-for="(value, key) in error_message.partner.email" :key="key"
                        class="form-error"> {{ value }}</span>
                </el-col>
              </el-col>
              <el-col :span="12" style="display: inline">
                <el-col :span="8">
                  <span class="form-lable">{{ $t('common.phone') }}</span>
                </el-col>
                <input class="input" v-model="parent_data.partner_info.phone" type=""/>
              </el-col>
            </el-row>
            <el-row style="padding-top: 20px">
              <el-col :span="12" style="display: inline">
                <el-col :span="8">
                  <span class="form-lable">{{ $t('common.address_1') }}</span>
                </el-col>
                <input class="input" v-model="parent_data.partner_info.address_1" type=""/>
              </el-col>
              <el-col :span="12" style="display: inline">
                <el-col :span="8">
                  <span class="form-lable">{{ $t('common.address_2') }}</span>
                </el-col>
                <input class="input" v-model="parent_data.partner_info.address_2" type=""/>
              </el-col>
            </el-row>
          </div>
        </div>

        <el-row class="row-section" style="height: 85px; padding-top: 30px">
          <el-button @click="addChildren()" style="float: left; margin-left: 20px;" type="success" icon="el-icon-plus"
                     circle></el-button>
          <span style="line-height: 40px;margin-left: 20px; font-size: 22px">{{ $t('add_parent.add_children') }}</span>

        </el-row>
        <div v-for="(item, index) in student_list" :key="index">
          <el-collapse>
            <el-collapse-item v-bind:class="{studentTitleError : error_message.student_list[index].isError }" style="margin-top: 20px;border-top: 1px solid #ffc107; border-bottom: 1px solid #ffc107"
                              :title=" `${$t('common.children')} ${index+1}: ${item.fullname}` ">
              <el-row style="text-align: left; padding: 20px 0;">
                <el-button @click="removeChild(index)" style="margin-right: 10px" type="danger"
                           icon="el-icon-minus" circle></el-button>
                <span style="font-size: 18px;">{{ $t('common.delete') }}</span>
              </el-row>
              <el-row >
                <el-col :span="12" style="display: inline">
                  <el-col :span="8">
                    <span class="required-star">* </span><span class="form-lable">{{ $t('common.full_name') }}</span>
                  </el-col>
                  <input class="input" v-model="student_list[index].fullname" type=""/>
                  <el-col v-if="error_message.student_list[index].fullname" :offset="8" :span="16">
                    <span v-for="(value, key) in error_message.student_list[index].fullname" :key="key"
                          class="form-error"> {{ value }}</span>
                  </el-col>
                </el-col>
              </el-row>
              <el-row style="padding-top: 20px">
                <el-col :span="12" style="display: inline">
                  <el-col :span="8">
                    <span class="form-lable">{{ $t('nameField.grade') }}</span>
                  </el-col>
                  <select style="" class="input" v-model="student_list[index].grade_id">
                    <option value="">{{ $t('common.please_select') }}</option>
                    <option v-for="grade in listGrade" v-bind:key="grade.id" :value="grade.id">{{
                        grade.name }}
                    </option>
                  </select>
                </el-col>
                <el-col :span="12" style="display: inline">
                  <el-col :span="8">
                    <span class="form-lable">{{ $t('common.class') }}</span>
                  </el-col>
                  <select style="" class="input" v-model="student_list[index].class_id">
                    <option value="">{{ $t('common.please_select') }}</option>
                    <option v-for="classroom in sortedClassList" v-bind:key="classroom.id" :value="classroom.id">{{
                      classroom.name }}
                    </option>
                  </select>
                </el-col>
              </el-row>
              <el-row style="padding-top: 20px">
                <el-col :span="12" style="display: inline">
                  <el-col :span="8">
                    <span class="required-star">* </span><span class="form-lable">{{ $t('common.furigana') }}</span>
                  </el-col>
                  <input class="input" v-model="student_list[index].furigana" type=""/>
                   <el-col v-if="error_message.student_list[index].furigana" :offset="8" :span="16">
                    <span v-for="(value, key) in error_message.student_list[index].furigana" :key="key"
                          class="form-error"> {{ value }}</span>
                  </el-col>
                </el-col>
                <el-col :span="12" style="display: inline">
                  <el-col :span="8">
                    <span class="form-lable">{{ $t('common.romaji') }}</span>
                  </el-col>
                  <input class="input" v-model="student_list[index].romaji" type=""/>
                </el-col>
              </el-row>
              <el-row style="padding-top: 20px">
                <el-col :span="12" style="display: inline">
                  <el-col :span="8">
                    <span class="required-star">* </span><span class="form-lable">{{ $t('common.gender') }}</span>
                  </el-col>
                  <select style="" class="input" v-model="student_list[index].gender">
                    <option value="0">{{ $t('common.female') }}</option>
                    <option value="1">{{ $t('common.male') }}</option>
                  </select>
                </el-col>
                <el-col :span="12" style="display: inline">
                  <el-col :span="8">
                    <span class="form-lable">{{ $t('common.relation_type') }}</span>
                  </el-col>
                  <select style="" class="input" v-model="student_list[index].relation_type">
                    <option value="0">{{ $t('common.unknown') }}</option>
                    <option value="1">{{ $t('common.second_child') }}</option>
                    <option value="2">{{ $t('common.first_child') }}</option>
                  </select>
                </el-col>
              </el-row>
              <el-row style="padding-top: 20px">
                <el-col :span="12" style="display: inline">
                  <el-col :span="8">
                    <span class="required-star">* </span><span class="form-lable">{{ $t('common.bus_stop') }}</span>
                  </el-col>
                  <select style="" class="input" v-model="student_list[index].place_id">
                    <option value="">{{ $t('common.please_select') }}</option>
                    <option v-for="place in sortedPlaceList" v-bind:key="place.id" :value="place.id">{{ place.name }}</option>
                  </select>
                  <el-col v-if="error_message.student_list[index].place" :offset="8" :span="16">
                    <span v-for="(value, key) in error_message.student_list[index].place" :key="key" class="form-error"> {{ value }}</span>
                  </el-col>
                </el-col>
                <el-col :span="12" style="display: inline">
                  <el-col :span="8">
                    <span class="form-lable">{{ $t('common.building_info') }}</span>
                  </el-col>
                  <input class="input" v-model="student_list[index].building_info" type=""/>
                </el-col>
              </el-row>
              <el-row style="padding-top: 20px">
                <el-col :span="12" style="display: inline">
                  <el-col :span="8">
                    <span class="form-lable">{{ $t('common.room_number') }}</span>
                  </el-col>
                  <input class="input" v-model="student_list[index].room_number" type=""/>
                </el-col>
                <el-col :span="12" style="display: inline">
                  <el-col :span="8">
                    <span class="form-lable">{{ $t('common.active') }}</span>
                  </el-col>
                  <el-switch style="float: left;" v-model="student_list[index].is_active"></el-switch>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12" style="display: inline">
                  <el-col :span="8">
                    <span class="form-lable">{{ $t('add_parent.isNotNeedPickedUp') }}</span>
                  </el-col>
                  <input type="checkbox" v-model="student_list[index].is_not_need_picked_up" name="" value="">
                </el-col>
              </el-row>
              <el-row class="row-section" style="height: 85px; padding-top: 30px">
                <el-button v-if="student_list[index].authorized_person_list.length <6" @click="addAgent(student_list[index], index)" style="float: left; margin-left: 20px;" type="success" icon="el-icon-plus"
                           circle></el-button>
                <span style="line-height: 40px;margin-left: 20px; font-size: 22px">{{ $t('add_parent.add_agent') }} {{student_list[index].authorized_person_list.length===6 ? $t('msg.maxItemCustom', {field: 6}): ''}}</span>
              </el-row>
              <div v-if="student_list[index].authorized_person_list.length > 0" style="padding: 0 30px">
                <div v-for="(item, i) in student_list[index].authorized_person_list" :key="i">
                  <div
                          v-bind:class="{studentTitleError : error_message.student_list[index].authorized_person_list[i].isError }"
                          style="margin-top: 20px;border-top: 1px solid #efefef; border-bottom: 1px solid #efefef; padding: 10px 0"
                          :title=" `${$t('common.agent')} ${i+1}: ${item.name}` ">
                    <el-row>
                      <el-col :span="7" style="display: inline">
                        <el-col :span="8">
                          <span class="required-star">* </span><span class="form-lable">{{ $t('common.full_name') }}</span>
                        </el-col>
                        <input class="input" v-model="student_list[index].authorized_person_list[i].name" type=""/>
                        <el-col v-if="error_message.student_list[index].authorized_person_list[i].name" :offset="8" :span="16">
                          <span v-for="(value, key) in error_message.student_list[index].authorized_person_list[i].name" :key="key"
                          class="form-error"> {{ value }}</span>
                        </el-col>
                      </el-col>
                      <el-col :span="7" style="display: inline">
                        <el-col :span="8">
                          <span class="required-star">* </span><span class="form-lable">{{ $t('common.phone') }}</span>
                        </el-col>
                        <input class="input" v-model="student_list[index].authorized_person_list[i].phone" type=""/>
                        <el-col v-if="error_message.student_list[index].authorized_person_list[i].phone" :offset="8" :span="16">
                          <span v-for="(value, key) in error_message.student_list[index].authorized_person_list[i].phone" :key="key"
                          class="form-error"> {{ value }}</span>
                        </el-col>
                      </el-col>
                      <el-col :span="8" style="display: inline">
                        <el-col :span="8">
                          <span class="form-lable">{{ $t('common.email') }}</span>
                        </el-col>
                        <input class="input" v-model="student_list[index].authorized_person_list[i].email" type=""/>
                        <el-col v-if="error_message.student_list[index].authorized_person_list[i].email" :offset="8" :span="16">
                          <span v-for="(value, key) in error_message.student_list[index].authorized_person_list[i].email" :key="key"
                                class="form-error"> {{ value }}</span>
                        </el-col>
                      </el-col>
                      <el-col :span="2">
                        <el-row style="text-align: left;">
                          <el-button @click="removeAgent(index,i)" style="margin-right: 10px" type="danger"
                                     icon="el-icon-minus" circle></el-button>
                          <span style="font-size: 18px;">{{ $t('common.delete') }}</span>
                        </el-row>
                      </el-col>
                    </el-row>
                  </div>
                </div>
              </div>

            </el-collapse-item>
          </el-collapse>
        </div>


        <el-row style="padding: 50px 0">
          <el-button style="font-size: 20px; width: 30%" type="success" @click="submitActionAddParent">{{ $t('common.submit') }}
          </el-button>
        </el-row>
      </form>
    </el-col>
  </div>
</template>

<script>
  import PageTitle from '@/components/PageTitle'
  import { classSort, basicSort } from '@/utils'
  import {mapState} from 'vuex'
  import {ACTIVE, NOT_ACTIVE} from "../../config";

  export default {
    name: "AddParent",
    components: {
      PageTitle
    },
    data: function () {
      return {
        backLink: `/parent?action=back`,
        title: 'add_parent.add_parent',
        gender_type: [{text: 'common.male', value: 1}, {text: 'common.female', value: 0}],
        listFiles: [],
        parent_data: {
          name: "",
          furigana: "",
          romaji: "",
          email: "",
          phone: "",
          is_member: false,
          attach_files: [],
          gender: 0,
          address_1: '',
          address_2: '',
          image: '',
          is_active: true,
          partner_info: {
            name: "",
            email: "",
            phone: "",
            gender: 0,
            furigana: '',
            romaji: '',
            address_1: '',
            address_2: '',
          },
          student_list: []
        },
        student_list: [],
        agent_list: [],
        error_message: {
          parent_name: [],
          email: [],
          phone: [],
          partner: {
            email: []
          },
          student_list: [],
          agent_list: []
        },
        hasPartner: false,
        listGrade: []
      }
    },
    created(){
      this.onGetListGrade()
    },
    methods: {
      onAddFile(){
        this.listFiles.push('')
        this.parent_data.attach_files.push('')
      },
      onDeleteFile(index){
        this.listFiles.splice(index , 1)
        this.parent_data.attach_files.splice(index, 1)
      },
      onGetListGrade(){
        let payload= {
          successCallback: (response) =>{
            if(response.status ===200){
              this.listGrade = response.data.data.data_list
            }
          },
          errorCallback: () =>{}
        }
        this.$store.dispatch('classroom/getGradeMaster', payload)
      },
      addChildren: function () {
        this.student_list.push({
          fullname: "",
          furigana: "",
          romaji: "",
          class_id: "",
          grade_id:"",
          parent_id: "",
          place_id: "",
          gender: 0,
          relation_parent: "",
          relation_type: 0,
          building_info: "",
          room_number: "",
          is_active: true,
          is_not_need_picked_up: false,
          authorized_person_list: []
        })
        this.error_message.student_list.push({fullname: [], class: [], place: [], isError: false, authorized_person_list: []})
      },
      addAgent: function (student, index) {
        if(student.authorized_person_list.length >= 11){
          this.$store.commit('openNotification', {
            type: 'error',
            message: this.$t('common.agent_is_limited')
          })
          return
        }
        student.authorized_person_list.push({
          name: "",
          phone: "",
          email:""
        })
        this.error_message.student_list[index].authorized_person_list.push({name: [], phone: [], email: []})
      },
      submitActionAddParent: function () {
        let check = this.validate()
        if (check) {
          let successCallback = () => {
            this.$router.push('/parent')
          };
          var formData = new FormData()
          for (let [key, value] of Object.entries(this.parent_data)) {
            if (key !== 'partner_info' && key !== 'student_list' && key !== 'authorized_person_list') {
              if (typeof value === 'boolean') {
                value = Number(value)
              }

              if (!value) {
                formData.append(key, '')
              } else {
                formData.append(key, value)
              }
            }
          }

          if(this.listFiles){
            let fileNotEmpty = this.listFiles.filter(elm => !!elm)
            fileNotEmpty.map((elm,index) => {
              formData.append('attach_files['+index+']', elm)
            })
          }

          if (this.hasPartner) {
            formData.append('partner_info[name]', this.parent_data.partner_info.name)
            formData.append('partner_info[furigana]', this.parent_data.partner_info.furigana)
            formData.append('partner_info[romaji]', this.parent_data.partner_info.romaji)
            formData.append('partner_info[address_1]', this.parent_data.partner_info.address_1)
            formData.append('partner_info[address_2]', this.parent_data.partner_info.address_2)
            formData.append('partner_info[phone]', this.parent_data.partner_info.phone)
            formData.append('partner_info[gender]', this.parent_data.partner_info.gender)
            formData.append('partner_info[email]', this.parent_data.partner_info.email)
          }
          for (const [key, value] of Object.entries(this.student_list)) {
            for (const [k, item] of Object.entries(value)) {
              if ((k === "building_info" || k === "room_number") && item == null) {
                formData.append('student_list['+key+']['+k+']', '')
              }else if(k === 'authorized_person_list') {
                item.forEach((jtem,index) => {
                  formData.append('student_list['+key+'][authorized_person_list]['+index+'][name]', jtem.name || '')
                  formData.append('student_list['+key+'][authorized_person_list]['+index+'][phone]', jtem.phone || '')
                  formData.append('student_list['+key+'][authorized_person_list]['+index+'][email]', jtem.email || '')
                })
              }else if(k === 'is_active' || k === 'is_not_need_picked_up'){
                formData.append('student_list['+key+']['+k+']', item ? ACTIVE : NOT_ACTIVE)
              }else{
                formData.append('student_list['+key+']['+k+']', item)
              }
            }
          }

          let payload = {
            successCallback,
            data: formData
          }
          this.$store.dispatch('parent/createParent', payload);
        } else {
          this.$store.commit('openNotification', {
            type: 'error',
            message: this.$t('common.please_check_input_error')
          })
          return false
        }
      },
      validate: function () {
        var check = true
        this.error_message.parent_name = []
        if (this.parent_data.name === "") {
          this.error_message.parent_name.push('* ' + this.$t('common.name_is_required'))
          check = false
        }
        if (this.validSpecialChar(this.parent_data.name)) {
          check = false
          this.error_message.parent_name.push('* ' + this.$t('common.name_cannot_contain_special_character'))
        }

        this.error_message.parent_furigana = []
        if (this.parent_data.furigana === "") {
          this.error_message.parent_furigana.push('* ' + this.$t('common.name_is_required'))
          check = false
        }
        if (this.validSpecialChar(this.parent_data.furigana)) {
          check = false
          this.error_message.parent_furigana.push('* ' + this.$t('common.name_cannot_contain_special_character'))
        }

        this.error_message.email = []
        if (!this.parent_data.email) {
          check = false
          this.error_message.email.push('* ' + this.$t('common.email_is_required'))
        } else if (!this.validEmail(this.parent_data.email)) {
          check = false
          this.error_message.email.push('* ' + this.$t('common.email_is_invalid'))
        }

        if (this.hasPartner) {
          this.error_message.partner.name = []
          if (!this.parent_data.partner_info.name.trim()) {
            this.error_message.partner.name.push('* ' + this.$t('common.name_is_required'))
            check = false
          }

          this.error_message.partner.email = []
          if (this.parent_data.partner_info.email && !this.validEmail(this.parent_data.partner_info.email)) {
            check = false
            this.error_message.partner.email.push('* ' + this.$t('common.email_is_invalid'))
          }
        }

        if (this.student_list.length) {
          for (const [key, value] of Object.entries(this.student_list)) {
            if (!this.validateStudentList(key, value)) check = false
            if (value.authorized_person_list.length) {
              for (const [k, agent] of Object.entries(value.authorized_person_list)) {
                if (!this.validateAgentList(key, k, agent)) check = false
              }
            }
          }
        }
        return check
      },
      validateStudentList(index, value) {
        var check = true

        this.error_message.student_list[index].fullname = []
        if (value.fullname === "") {
          check = false
          this.error_message.student_list[index].fullname.push('* ' + this.$t('common.name_is_required_child'))
        }
        if (this.validSpecialChar(value.fullname)) {
          check = false
          this.error_message.student_list[index].fullname.push('* ' + this.$t('common.name_cannot_contain_special_character_child'))
        }

        this.error_message.student_list[index].furigana = []
        if (value.furigana === "") {
          check = false
          this.error_message.student_list[index].furigana.push('* ' + this.$t('common.name_is_required_child'))
        }
        if (this.validSpecialChar(value.furigana)) {
          check = false
          this.error_message.student_list[index].furigana.push('* ' + this.$t('common.name_cannot_contain_special_character_child'))
        }
        this.error_message.student_list[index].class = []
        this.error_message.student_list[index].place = []
        if (value.place_id === "") {
          check = false
          this.error_message.student_list[index].place.push('* ' + this.$t('common.bus_stop_is_required'))
        }

        this.error_message.student_list[index].isError = !check
        return check
      },
      validateAgentList(key, index, value) {
        var check = true
        this.error_message.student_list[key].authorized_person_list[index].name = []
        if (value.name === "") {
          check = false
          this.error_message.student_list[key].authorized_person_list[index].name.push('* ' + this.$t('common.name_is_required'))
        }
        if (this.validSpecialChar(value.name)) {
          check = false
          this.error_message.student_list[key].authorized_person_list[index].name.push('* ' + this.$t('common.name_cannot_contain_special_character'))
        }

        this.error_message.student_list[key].authorized_person_list[index].phone = []
        if (value.phone === "") {
          check = false
          this.error_message.student_list[key].authorized_person_list[index].phone.push('* ' + this.$t('common.phone_is_required'))
        }

        this.error_message.student_list[key].authorized_person_list[index].email = []
        if (value.email && !this.validEmail(value.email)) {
            check = false
            this.error_message.student_list[key].authorized_person_list[index].email.push('* ' + this.$t('common.email_is_invalid'))
        }
        this.error_message.student_list[key].authorized_person_list[index].isError = !check
        return check
      },
      validSpecialChar: function (text) {
        var specialChar = /[!@#$%^&*()_+\-=\]{};':"\\|,.<>?]/;
        return specialChar.test(text)
      },
      validEmail: function (email) {
        var re = /^(([^<>()\]\\.,;:\s@"]+(\.[^<>()\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3})|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
      },
      removeAgent(index, i) {
        this.$store.commit('openConfirm', {
          title: this.$t('common.delete'),
          message: this.$t('common.agent_delete_confirm'),
          callback: () => {
            this.student_list[index].authorized_person_list.splice(i, 1)
          }
        })
      },
      removeChild(index) {
        this.$store.commit('openConfirm', {
          title: this.$t('common.delete'),
          message: this.$t('common.student_delete_confirm'),
          callback: () => {
            this.student_list.splice(index, 1)
            this.error_message.student_list.splice(index, 1)
          }
        })
      },
    },
    mounted: function () {
      this.$store.dispatch('classroom/retrieveClassList', {})
      this.$store.dispatch('place/retrievePlaceList', {})
    },
    computed: {
      ...mapState('classroom', ['classList']),
      ...mapState('place', ['placeList']),
      ...mapState('parent', ['parentInfo']),
      sortedClassList: function () {
        let sortedClassList = [].concat(this.classList)
        sortedClassList.sort((before, after) => classSort(before, after))
        return sortedClassList
      },
      sortedPlaceList: function () {
        let sortedPlaceList = [].concat(this.placeList)
        sortedPlaceList.sort((before, after) => basicSort(before, after, 'name'))
        return sortedPlaceList
      }
    },
    watch: {
      parentInfo: {
        deep: true,
        handler: function () {

        }
      },
    }
  }
</script>

<style lang="scss">
  .row-section {
    height: 50px;
    border-bottom: 1px solid #f8f9fa;
    margin: 20px 0;
    text-align: left;
    color: #ffac41;
  }

  .required-star {
    float: left;
    color: #CA0A0A;
    font-size: 25px;
    font-weight: 900;
    margin-right: 5px;
  }

  .add-parent .el-collapse-item__header,
  .edit-parent .el-collapse-item__header {
    font-size: 22px;
  }

  .add-parent .el-collapse,
  .edit-parent .el-collapse {
    border-top: none !important;
  }

  .form-error {
    float: left;
    color: red;
    font-size: 12px;
    &-passw{
      margin-left: 128px;
    }
    &-vn{
      margin-left: 120px !important;
    }
  }

  .studentTitleError {
    border-top: 2px solid red !important; border-bottom: 2px solid red !important;
  }
</style>
